import { Identified } from "@/types/sdk-types";
import { useQuery } from "@tanstack/react-query";
import {
  getConfigObject,
  getXtenantId,
  useBaseContent,
} from "../../utils/utils";
import { SuperBillControllerApi, SuperBill } from "../../services";

/**
 *
 * @author Atish Bagate
 */
interface GetSuperBillCMS1500ByIdProps {
  superBillUuid: string;
}

export function useGetSuperBillCMS1500ById({
  superBillUuid,
}: GetSuperBillCMS1500ByIdProps): useBaseContent<Identified<SuperBill>> {
  return useQuery({
    queryKey: ["Get-super-bill-CMS1500-by-id", superBillUuid],
    enabled: !!superBillUuid,
    queryFn: async () =>
      new SuperBillControllerApi(getConfigObject())
        .getSuperBillCms1500Print(superBillUuid, getXtenantId() ?? "")
        .then((it) => it?.data),
  });
}
